import React from 'react';
import { motion } from 'framer-motion';
const services = [{
  name: 'Afeitado Imperial',
  image: 'https://cdn.magicpatterns.com/uploads/3vDUtfuHZQxEvX5en9SoYv/afeitado_imperial.jpg'
}, {
  name: 'Corte de Pelo',
  image: 'https://cdn.magicpatterns.com/uploads/eNZQJeqLQGYf423Ezmq9zp/corte_de_pelo.jpg'
}, {
  name: 'Desvanecido',
  image: 'https://cdn.magicpatterns.com/uploads/7kBPcmat8BaY8zwSGf1vbZ/desvanecido.jpg'
}, {
  name: 'Diseño de Cejas',
  image: 'https://cdn.magicpatterns.com/uploads/fsPsk7ttDz4sphfEAmrCja/diseno_de_cejas.jpg'
}, {
  name: 'Mascarilla Negra',
  image: 'https://cdn.magicpatterns.com/uploads/8edmTnQ6hPJbBRCi5wBY6x/mascarilla_negra.jpg'
}, {
  name: 'Perfilado de Barba',
  image: 'https://cdn.magicpatterns.com/uploads/oorZDvqb2aVuDM9eCBRPNc/perfilado_de_barba.jpg'
}];
export function SteelStandard() {
  return <section id="servicios" className="py-24 md:py-32 relative" data-id="element-181">
      <div className="container mx-auto px-6 md:px-12" data-id="element-182">
        <motion.div className="text-center mb-20" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-183">
          <h2 className="font-serif text-4xl md:text-5xl mb-4" data-id="element-184">
            Servicios <span className="text-gold italic" data-id="element-185">Populares</span>
          </h2>
          <p className="text-white/60 font-light mb-6" data-id="element-186">
            La excelencia en cada detalle
          </p>
          <div className="w-24 h-[1px] bg-gold mx-auto" data-id="element-187"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-188">
          {services.map((service, index) => <motion.div key={index} className="relative group rounded-2xl overflow-hidden aspect-[4/5] shadow-xl shadow-black/50 cursor-pointer" initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.1
        }} data-id="element-189">
              <img src={service.image} alt={service.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-190" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" data-id="element-191"></div>

              <div className="absolute inset-0 flex items-end justify-center pb-10 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-4 group-hover:translate-y-0" data-id="element-192">
                <div className="text-center" data-id="element-193">
                  <div className="w-8 h-[1px] bg-gold mx-auto mb-3" data-id="element-194"></div>
                  <h3 className="font-serif text-2xl text-white tracking-wide" data-id="element-195">
                    {service.name}
                  </h3>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}